// extracted by mini-css-extract-plugin
module.exports = {"button":"CloseModalButton_button__2HAGb"};